import { render, staticRenderFns } from "./ShoppingAdd.vue?vue&type=template&id=d7fa6bfa"
import script from "./ShoppingAdd.vue?vue&type=script&lang=js"
export * from "./ShoppingAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports